import React from 'react';
import './_Modal.css';
import './PolicyDetailModal.css';
import { formatDateTime } from '../utils/date';

const PolicyDetailModal = ({ policy, onClose, onEdit, onDelete, canManage }) => {
    if (!policy) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>{policy.name}</h2>
                <div className="policy-meta">
                    <div className="meta-row">
                        <span className="meta-label">Created:</span>
                        <span className="meta-value">{policy.created_by && `${policy.created_by.first_name} ${policy.created_by.last_name}`} at {formatDateTime(policy.created_at)}</span>
                    </div>
                    <div className="meta-row">
                        <span className="meta-label">Updated:</span>
                        <span className="meta-value">{policy.last_updated_by && `${policy.last_updated_by.first_name} ${policy.last_updated_by.last_name}`} at {formatDateTime(policy.last_updated_at)}</span>
                    </div>
                </div>
                <textarea className="policy-text-full" readOnly value={policy.text} />
                <div>
                    {canManage && (
                        <>
                            <div className='actions-centered'>
                                <button className="cancel-button text-button" onClick={onEdit}>Edit</button>
                                <button className="submit-button text-button" onClick={onDelete}>Delete</button>
                            </div>
                        </>
                    )}
                    <button className="modal-close" onClick={onClose}>X</button>
                </div>
            </div>
        </div>
    );
};

export default PolicyDetailModal;